<template>
  <v-row>
    <!-- Step 1 -->
    <v-col md="8" v-if="!model" cols="12" class="text-center mx-auto">
      <h1>{{$t('alerts.select_city')}}</h1>
      <v-autocomplete
        v-model="model"
        :items="items"
        :loading="isLoading"
        filled
        :search-input.sync="search"
        hide-no-data
        hide-selected
        item-text="search_nom"
        return-object
        no-filter
        rounded
        :placeholder="$t('city_or_cp')"
      />
    </v-col>

    <!-- Step 2 -->
    <v-col md="8" v-if="model" cols="12" class="text-center mx-auto">
      <h1>{{$t('alerts.alerts_for')}} {{ model.nom }}</h1>
      <i>{{$t('alerts.mandatory_fields')}}</i>
      <v-form @submit:prevent="createOrUpdateAlert()">
        <v-list>
          <v-list-item 
              v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-text-field
              rounded
              label="Température d'air supérieur à"
              type="number"
              placeholder="ex: 20 °C "
              v-model="form['temp-max']"
              filled
              suffix="°C"
            />
          </v-list-item>
          <v-list-item 
              v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-text-field
              rounded
              label="Température d'air inférieur à"
              type="number"
              v-model="form['temp-min']"
              placeholder="ex: 0 °C "
              filled
              suffix="°C"
            />
          </v-list-item>
          <v-list-item 
              v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-text-field
              rounded
              v-model="form.wind"
              label="Vent supérieur à"
              type="number"
              placeholder="ex: 50 km/h "
              filled
              suffix="km/h"
            />
          </v-list-item>
          <v-list-item 
              v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-text-field
              rounded
              v-model="form['rain-max']"
              label="Cumul de précipitations supérieur à"
              type="number"
              placeholder="ex: 1 mm/h"
              filled
              suffix="mm/h"
            />
          </v-list-item>
          <v-list-item v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-checkbox  v-model="form.snow" label="Alerte si risque de neige" />
          </v-list-item>
          <v-list-item>
            <v-checkbox
              v-model="form.storm"
              label="Alerte si risque de d'orage"
            />
          </v-list-item>
          <v-list-item v-if="!$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-checkbox
              v-model="form.ice"
              label="Alerte si risque de verglas"
            />
          </v-list-item 
              >
          <v-list-item    v-if="user.features.find((map) => map == 'real_time_alerts') && !$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-checkbox
         
              v-model="form['rain-now']"
              label="Alerte si risque de pluie en temps réel"
            />
          </v-list-item >
          <v-list-item v-if="user.features.find((map) => map == 'multimodele') && !$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-checkbox
            
              v-model="form['multi_pluie']"
              label="Alerte pluie multi-modèle"
            />
          </v-list-item>
          <v-list-item v-if="user.features.find((map) => map == 'multimodele') && !$env.VUE_APP_WHITE_MARK_ID == 'fp'">
            <v-checkbox
            
              v-model="form['multi_temp']"
              label="Alerte température multi-modèle"
            />
          </v-list-item>
        </v-list>
        <v-btn
        class="mb-16"
          rounded
          block
          color="primary"
          :loading="loading"
          @click="UpdateOrCreate()"
          elevation="0"
          >Soumettre</v-btn
        >
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? {
              ...chunk,
              search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
            }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },
  },
  methods: {
    async UpdateOrCreate() {
      try {
        let obj = [];
        Object.entries(this.form).forEach((element) => {
          if (element[1]) {
            if (typeof element[1] == "boolean") {
              element[1] = 1;
            }
            let preObj = {
              key: element[0],
              number: element[1],
            }
            if(element[0] == 'rain-now')
            {
              preObj.number = null;
              preObj.bool = element[1] ? true : false
            }
            obj.push(preObj);
          }
        });
        this.loading = true;
        await api.alert.createAlert(this.user.id_user, this.model.geoname, obj);
      } catch (err) {
        console.log(err);
      }
      this.$router.push("/alertes/v2/list");
      this.loading = false;
    },
  },
  data: () => ({
    city: null,
    isLoading: false,
    entries: [],
    loading: false,
    count: 0,
    model: null,
    search: null,
    form: {
      "temp-max": null,
      "temp-min": null,
      "multi_pluie":null,
      "multi_temp":null,
      wind: null,
      "rain-max": null,
      snow: false,
      storm: false,
      "rain-now": null,
      ice: false,
    },
  }),
  async mounted() {
    console.log(this.$route);
    if(this.$env.VUE_APP_WHITE_MARK_ID == 'fp')
    {
      this.form.storm = true;
    }
    if(this.$route.query.geoname)
    {
      let res = await api.cities.getinfos(this.$route.query.geoname)
      console.log(res);
      this.model = {
        cp: res.admin4_code,
        geoname: this.$route.query.geoname,
        iso: res.paysIso2,
        lat: res.lat,
        lon: res.lon,
        nom: res.name
      };
    }
  },
  watch: {
    search(val) {

      this.isLoading = true;

      // Lazily load input items
      api.cities
        .search(val)
        .then((res) => {
          this.entries = res;
          this.count = res.length;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style>

.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content {
    top: 68px!important;
}

</style>